/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcChevronRightSmallRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M9.363 5.364a.9.9 0 0 0 0 1.272L14.727 12l-5.364 5.364a.9.9 0 0 0 1.273 1.273l6-6a.9.9 0 0 0 0-1.273l-6-6a.9.9 0 0 0-1.273 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcChevronRightSmallRegular;
